import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyD4tWxv_FggveHgsXIjcrEn1QOUHWKeo4Q',
  authDomain: 'mintech-ecosystem.firebaseapp.com',
  projectId: 'mintech-ecosystem',
  storageBucket: 'mintech-ecosystem.firebasestorage.app',
  messagingSenderId: '459291292814',
  appId: '1:459291292814:web:c4b4b32cb23c8384d9c5df'
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const provider = new GoogleAuthProvider();

const db = getFirestore(app, 'main');

export { app, auth, provider, db };
